// extracted by mini-css-extract-plugin
module.exports = {"list":"QuoteList_list__1w6Ob","sorting":"QuoteList_sorting__1iyxW"};